import { Routes, RouterModule } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { NeoAuthGuard } from './guards/neo-auth.guard';
import { FailedComponent } from '@app/pages/failed/failed.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { ClearStorageComponent } from '@app/pages/clear-storage/clear-storage.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: (): any => import('@app/layout/layout.module').then((m) => m.LayoutModule),
    canActivate: [NeoAuthGuard]
  },
  {
    path: 'client-approve-timesheets',
    loadChildren: (): any => import('@app/client-approve-timesheets/client-approve-timesheets.module').then((m) => m.ClientApproveTimesheetModule),
    canActivate: [NeoAuthGuard]
  },
  {
    path: 'pending',
    loadChildren: (): any => import('@app/client-approve-timesheets/client-approve-timesheets.module').then((m) => m.ClientApproveTimesheetModule),
    canActivate: [NeoAuthGuard]
  },
  // Auth check route - NO GUARD - must be accessible without authentication
  {
    path: 'auth-check',
    title: 'Neo One - Initializing',
    loadComponent: (): any => import('@app/pages/auth-check/auth-check.component').then((m) => m.AuthCheckComponent)
  },
  { path: 'clear-storage', title: 'Neo One - Clear Storage', component: ClearStorageComponent }, // No guard - accessible anytime
  { path: 'login-failed', title: 'Neo One - Login Failed', component: FailedComponent },
  { path: 'page-not-found', title: 'Neo One - Page Not Found', component: PageNotFoundComponent },
  { path: '**', redirectTo: 'page-not-found' },
];

const isIframe = window !== window.parent && !window.opener;

export const appRoutingModule = RouterModule.forRoot(routes, {
  // CRITICAL: enabledBlocking ensures MSAL completes initialization and populates accounts
  // BEFORE navigation begins. This prevents race conditions with authentication checks.
  // MsalRedirectComponent processes OAuth callbacks during this blocking period.
  initialNavigation: !isIframe ? 'enabledBlocking' : 'disabled',
});
